/* AagamStuti product variants. Plain JavaScript, no libraries. Linked by sections/main-product.liquid, after aagamstuti.js.
   aagamstuti.js still picks the variant, price, picture and bag button. This file adds:
   - sensible order for number and size options (6 in before 8 in, Small before Big)
   - choosing a value that no longer fits the others moves the others to the nearest variant that exists
   - an "Only 3 left" line for variants that are running low
   - the phone buy bar follows the main button (sold out, wording)
   - "Also available in": products that are the same piece in another size or colour, found through the shop's own search */
(function () {
  'use strict';

  var doc = document;
  var AS = window.AS || {};
  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }

  /* ---------- Money, in the store's own format ---------- */
  function group(n, sep) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
  function money(cents) {
    var f = AS.moneyFormat || '{{amount}}';
    var whole = Math.floor(cents / 100), frac = ('0' + (cents % 100)).slice(-2);
    var withDec = function (thousand, dec) { var s = group(whole, thousand); return frac === '00' ? s : s + dec + frac; };
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, name) {
      switch (name) {
        case 'amount_no_decimals': return group(whole, ',');
        case 'amount_with_comma_separator': return withDec('.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(whole, '.');
        case 'amount_with_apostrophe_separator': return withDec("'", '.');
        case 'amount_no_decimals_with_space_separator': return group(whole, ' ');
        case 'amount_with_space_separator': return withDec(' ', ',');
        default: return withDec(',', '.');
      }
    });
  }

  /* ---------- Order of values ---------- */
  var RANK = { xs: 0, 'extra small': 0, mini: 1, small: 1, s: 1, regular: 2, normal: 2, standard: 2, medium: 2, m: 2, large: 3, l: 3, big: 3, xl: 4, 'extra large': 4, jumbo: 4, xxl: 5, king: 5 };
  function sortValues(sec) {
    $$('[data-option]', sec).forEach(function (grp) {
      var wrap = $('.as-sizes', grp);
      var btns = $$('button[data-value]', grp);
      if (!wrap || btns.length < 2) return;
      var keys = btns.map(function (b) {
        var v = b.getAttribute('data-value').trim().toLowerCase();
        var m = /^(\d+(?:\.\d+)?)/.exec(v);
        if (m) return parseFloat(m[1]);
        return Object.prototype.hasOwnProperty.call(RANK, v) ? RANK[v] : NaN;
      });
      if (keys.some(function (k) { return isNaN(k); })) return;
      btns.map(function (b, i) { return { b: b, k: keys[i], i: i }; })
        .sort(function (a, c) { return a.k - c.k || a.i - c.i; })
        .forEach(function (p) { wrap.appendChild(p.b); });
    });
  }

  /* ---------- Other sizes and colours that are separate products ---------- */
  var SIZE_WORD = /\s+(extra large|x-large|xx-large|xxl|xl|large|medium|small|mini)$/i;
  var SIZE_LETTER = /\s+(XXL|XL|L|M|S)$/;
  var BRACKET = /\s*[(\[]([^()\[\]]{1,24})[)\]]\s*$/;
  function familyOf(title) {
    var t = String(title || '').replace(/\s+/g, ' ').trim();
    var m = BRACKET.exec(t) || SIZE_WORD.exec(t) || SIZE_LETTER.exec(t);
    if (!m) return null;
    var key = t.slice(0, m.index).replace(/[\s|,:\-–]+$/, '').toLowerCase();
    return key.length > 3 ? { key: key, label: m[1].trim() } : null;
  }
  function loadSiblings(sec) {
    var box = $('[data-siblings]', sec);
    if (!box || !window.fetch || box.hasAttribute('data-server')) return;
    var me = familyOf(box.getAttribute('data-title'));
    if (!me) return;
    var handle = box.getAttribute('data-handle');
    var base = (AS.routes && AS.routes.suggest) || '/search/suggest';
    var q = me.key.split(' ').slice(0, 10).join(' ');
    fetch(base + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var items = j && j.resources && j.resources.results && j.resources.results.products;
        if (!items) return;
        var fam = [];
        items.forEach(function (p) {
          var f = familyOf(p.title);
          if (!f || f.key !== me.key) return;
          fam.push({ label: f.label, url: String(p.url || '').split('?')[0], cents: Math.round(parseFloat(p.price) * 100), ok: p.available !== false, here: p.handle === handle });
        });
        if (!fam.some(function (x) { return x.here; })) {
          var cur = $('[data-price]', sec);
          fam.push({ label: me.label, url: location.pathname, text: cur ? cur.textContent : '', ok: true, here: true });
        }
        if (fam.length < 2) return;
        fam.sort(function (a, b) {
          var ra = RANK[a.label.toLowerCase()], rb = RANK[b.label.toLowerCase()];
          if (ra !== undefined && rb !== undefined && ra !== rb) return ra - rb;
          return (a.cents || 0) - (b.cents || 0);
        });
        var list = $('[data-sib-list]', box);
        list.textContent = '';
        fam.forEach(function (x) {
          var a = doc.createElement('a');
          a.href = x.url;
          if (x.here) a.setAttribute('aria-current', 'page');
          if (!x.ok) a.className = 'is-soldout';
          var name = doc.createElement('span'); name.textContent = x.label;
          a.appendChild(name);
          var price = x.text || (x.cents > 0 ? money(x.cents) : '');
          if (price) { var s = doc.createElement('small'); s.textContent = price; a.appendChild(s); }
          list.appendChild(a);
        });
        box.hidden = false;
      })
      .catch(function () {});
  }

  /* ---------- One product section ---------- */
  function init(sec) {
    if (sec.getAttribute('data-var-ready')) return;
    sec.setAttribute('data-var-ready', '1');
    var data = [];
    try { data = JSON.parse($('[data-variants]', sec).textContent); } catch (e) { return; }
    var opts = $$('[data-option]', sec);
    var stock = $('[data-stock]', sec);
    var low = Number(sec.getAttribute('data-low-stock')) || 0;

    sortValues(sec);

    function selected() {
      return opts.map(function (g) { var b = $('[aria-pressed="true"]', g); return b ? b.getAttribute('data-value') : null; });
    }
    function find(sel) {
      return data.filter(function (v) {
        return sel.every(function (val, i) { return val === null || v['o' + (i + 1)] === val; });
      })[0];
    }

    /* Before aagamstuti.js reads the click: if the chosen value has no variant with the other chosen values, move the others */
    on(sec, 'click', function (e) {
      var b = e.target.closest('[data-option] button[data-value]');
      if (!b || opts.length < 2) return;
      var gi = opts.indexOf(b.closest('[data-option]'));
      var sel = selected();
      sel[gi] = b.getAttribute('data-value');
      if (find(sel)) return;
      var best = null, bestScore = -1;
      data.forEach(function (v) {
        if (v['o' + (gi + 1)] !== sel[gi]) return;
        var score = v.available ? 0.5 : 0;
        sel.forEach(function (val, i) { if (i !== gi && v['o' + (i + 1)] === val) score += 1; });
        if (score > bestScore) { best = v; bestScore = score; }
      });
      if (!best) return;
      opts.forEach(function (g, i) {
        if (i === gi) return;
        $$('button[data-value]', g).forEach(function (x) {
          x.setAttribute('aria-pressed', x.getAttribute('data-value') === best['o' + (i + 1)] ? 'true' : 'false');
        });
      });
    }, true);

    /* The phone bar under the page follows the main button: same wording, and off when the option is sold out */
    var sbtn = $('[data-sticky-add]', sec), mainBtn = $('[data-add-to-cart]', sec), mainLabel = $('[data-add-label]', sec);
    function syncSticky() {
      if (!sbtn || !mainBtn) return;
      sbtn.disabled = mainBtn.disabled;
      var l = $('span', sbtn);
      if (l && mainLabel) l.textContent = mainLabel.textContent;
    }

    /* After aagamstuti.js has updated the page */
    function refresh() {
      syncSticky();
      if (!stock) return;
      var v = find(selected());
      var few = !!(v && v.available && low > 0 && v.track && !v.oversell && v.qty > 0 && v.qty <= low);
      if (few) stock.textContent = 'Only ' + v.qty + ' left';
      stock.classList.toggle('is-low', few);
    }
    on(sec, 'click', function (e) { if (e.target.closest('[data-option] button[data-value]')) refresh(); });
    refresh();

    loadSiblings(sec);
  }

  function boot(ctx) { $$('[data-product-section]', ctx).forEach(init); }
  boot(doc);
  on(doc, 'shopify:section:load', function (e) { boot(e.target); });
})();